import { AnnotationType } from './types';

const isSupportedAnnotationType = (annotationType: string): boolean =>
  // TOOD: Fix typing
  Object.values(AnnotationType).includes(annotationType as AnnotationType);

export default isSupportedAnnotationType;
